import { Http } from './http';
import { LookerLog } from '../types';

class GcpHttp extends Http {
  prefix = 'gcp';

  async getLogs(): Promise<LookerLog[]> {
    const res = await this.get<LookerLog[]>('/get-logs');

    return res.data;
  }

  async runActionUrl(url: string, dto?: GcpDto) {
    const res = await this.post<LookerLog>(`/${url}`, dto);

    return res.data;
  }

  async batchTraining(): Promise<LookerLog> {
    const res = await this.post<LookerLog>('/batch-training');

    return res.data;
  }

  async scoresPredict(): Promise<LookerLog> {
    const res = await this.post<LookerLog>('/scores-predict');

    return res.data;
  }

  async showMetaData(): Promise<LookerLog> {
    const res = await this.post<LookerLog>('/show-meta-data');

    return res.data;
  }

  async fineTuning(): Promise<LookerLog> {
    const res = await this.post<LookerLog>('/fine-tuning');

    return res.data;
  }

  async predict(): Promise<LookerLog> {
    const res = await this.post<LookerLog>('/predict');

    return res.data;
  }

  async deleteGcsObjects(): Promise<LookerLog> {
    const res = await this.post<LookerLog>('/delete-gcs-objects');

    return res.data;
  }
}

interface GcpDto {
  code?: string | null;
}

export const gcpHttp = new GcpHttp();

